import React, { useEffect, useState } from "react";
import axios from "axios";
import WarningUploadImage from "../WarningUploadImage/WarningUploadImage";
import { environment } from "../../environments/environments";
import "../CounsellorAllPages/CounsellorImageUpload.css";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import bgImage from "../../assets/images/brown-background.jpg";
const CounsellorImageUpload = () => {
  const MAX_IMAGE_SIZE = 2 * 1024 * 1024; // 2MB
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    setIsModalVisible(true);
  }, []);

  const validateImageSize = (file) => {
    if (file && file.size > MAX_IMAGE_SIZE) {
      //   alert("The selected image exceeds the maximum size of 2 MB.");
      Swal.fire({
        icon: "error",
        title: "Too Large!",
        text: "The selected image exceeds the maximum size of 2 MB.",
      });
      return false;
    }
    return true;
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file && validateImageSize(file)) {
      setImage(file);
    }
  };

  const handleContinue = async () => {
    if (!image) {
      //   alert("Please choose an image to continue.");
      Swal.fire({
        icon: "warning",
        title: "No Image Selected",
        text: "Please choose an image to continue.",
      });
      return;
    }

    const formData = new FormData();
    setIsLoading(true);

    try {
      const userDatas = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatas);
      const _id = parsedUserData?.id || parsedUserData?._id;

      formData.append("counsellor_id", _id);
      formData.append("profile_completion_status", "uploadDocument");
      formData.append("image", image);

      const response = await axios.post(
        `${environment.baseURL}/update-counsellor`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data?.success === true) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: response.data?.message,
        }).then(() => navigate("/CounsellorDoucmentation"));
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data?.message,
        });
      }
    } catch (error) {
      console.error("Upload Error:", error);
      Swal.fire({
        icon: "error",
        title: "Upload Failed",
        text: "Something went wrong while uploading the image.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="counsellorimageUpload sechdr-toppding"
      style={{
        backgroundImage: `url(${bgImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}>
      <div className="containerall">
        <div className="upload-container">
          {isModalVisible && (
            <WarningUploadImage setIsModalVisible={setIsModalVisible} />
          )}

          <p className="instructions">
            Tap to upload an image from camera or gallery
          </p>

          <label className="image-upload-box">
            {image ? (
              <img
                src={URL.createObjectURL(image)}
                alt="Selected"
                className="preview-image"
              />
            ) : (
              <span className="placeholder-text">Click to select image</span>
            )}
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ display: "none" }}
            />
          </label>

          <button
            className="continue-button"
            onClick={handleContinue}
            disabled={isLoading}
          >
            {isLoading ? "Uploading..." : "Continue"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CounsellorImageUpload;
